<template>
    <div class="main-wrapper scroll-y custom-scrollbar with-tabs view-user-contact-form" style="background: #fff">

        <page-title :title="'Formularz kontaktowy'" :back="true"></page-title>

        <slide-y-up-transition :duration="500" :delay="200">
            <div v-show="show" class="box-info text-center">W czym możemy Ci pomóc?</div>
        </slide-y-up-transition>

        <form-contact></form-contact>

    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import PageTitle from '@/components/PageTitle.vue';
    import FormContact from '@/forms/FormContact.vue';

    export default {
        name: 'UserContactForm',
        components: { PageTitle, FormContact },
        data() {
            return {
                show: false,
            }
        },
        mounted(){
            this.show = true;
            this.$store.dispatch('contact/CONTACT_SUBJECTS_REQUEST');
        }
    }
</script>